import { useState } from "react";

import { STATUS_LABELS } from "@/components/pipeline/utils";

export const BulkBar = ({ count, meta, steps, onRun, onClear, busy }) => {
  const [action, setAction] = useState("step");
  const [value, setValue] = useState("");
  const options = {
    step: steps.map((s) => ({ v: s.id, l: s.name })),
    assign: meta.users.map((u) => ({ v: u.user_id, l: u.name })),
    status: Object.entries(STATUS_LABELS).filter(([k]) => k !== "standby").map(([v, l]) => ({ v, l })),
  };
  return (
    <div className="pl-bulk" data-testid="bulk-action-bar">
      <strong>{count} sélectionnée{count > 1 ? "s" : ""}</strong>
      <select value={action} onChange={(e) => { setAction(e.target.value); setValue(""); }} data-testid="bulk-action-select">
        <option value="step">Changer d'étape</option>
        {meta.me.is_admin && <option value="assign">Attribuer à</option>}
        <option value="add_tag">Ajouter un tag</option>
        <option value="status">Changer le statut</option>
      </select>
      {action === "add_tag"
        ? <input value={value} placeholder="Nom du tag" onChange={(e) => setValue(e.target.value)} data-testid="bulk-action-value" />
        : (
          <select value={value} onChange={(e) => setValue(e.target.value)} data-testid="bulk-action-value">
            <option value="">{action === "step" && !steps.length ? "Choisissez un pipeline" : "Choisir…"}</option>
            {options[action].map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        )}
      <button type="button" className="primary-button" disabled={!value || busy || count > 100} onClick={() => onRun(action, value)} data-testid="bulk-action-apply">{busy ? "En cours…" : count > 100 ? "100 max" : "Appliquer"}</button>
      <button type="button" className="pl-link light" onClick={onClear} data-testid="bulk-action-clear">Désélectionner</button>
    </div>
  );
};
